/*
 * Copyright (c) 2022 by 安徽网才信息技术股份有限公司
 *
 * 除非事先获得版权所有人的许可, 禁止以下几项行为:
 * 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
 * 2. 向第三方透露任何与该软件相关的源代码或技术文档。
 * 3. 更改或删除软件或源码中的版权声明。
 *
 */
import api from '@/utils/api.request';

// 验证码登录
export const smsLogin = (data) => {
    return api.request({
        url: 'user/login/sms',
        method: 'post',
        data
    });
};

// 密码登录
export const passwordLogin = (data) => {
    return api.request({
        url: 'user/login/password',
        method: 'post',
        data
    });
};

// 获取用户基本信息
export const getUserInfo = () => {
    return api.request({
        url: 'user/base-info',
        method: 'get'
    });
};

// 设置密码
export const setPassword = (data) => {
    return api.request({
        url: 'user/set-password',
        method: 'post',
        data
    });
};

// 修改密码
export const modifyPassword = (data) => {
    return api.request({
        url: 'user/change-password',
        method: 'post',
        data
    });
};

// 退出登录
export const logout = () => {
    return api.request({
        url: 'user/logout',
        method: 'get'
    });
};

// 验证码校验
export const checkSms = (data) => {
    return api.request({
        url: 'user/verify-code',
        method: 'post',
        data
    });
};

// 发短信验证码
export const sendSms = (data) => {
    return api.request({
        url: 'frontend/sms',
        method: 'post',
        data
    });
};

// 获取用户详细信息
export const getUserDetailInfo = () => {
    return api.request({
        url: 'user/detail-info',
        method: 'get'
    });
};

// 取消第一次编辑用户信息
export const cancelSaveInfo = () => {
    return api.request({
        url: 'user/cancel-save',
        method: 'get'
    });
};

// 保存用户信息
export const saveInfo = (data) => {
    return api.request({
        url: 'user',
        method: 'post',
        data
    });
};

// 检查手机号是否可用
export const checkMobileUsed = (params) => {
    return api.request({
        url: 'user/check-mobile-used',
        method: 'get',
        params
    });
};

// 修改手机号
export const modifyMobile = (data) => {
    return api.request({
        url: 'user/mobile',
        method: 'post',
        data
    });
};

// 获取用户报考列表
export const getUserApply = () => {
    return api.request({
        url: 'user/apply',
        method: 'get'
    });
};

// 注销账户
export const closeAccount = (data) => {
    return api.request({
        url: 'user/close-account',
        method: 'post',
        data
    });
};

// 极验验证初始化
export const getGeetestRegister = () => {
    return api.request({
        url: 'smart-verification/geetest/register',
        method: 'post'
    });
};

// 极验二次校验
export const getGeetestValidate = (data) => {
    return api.request({
        url: 'smart-verification/geetest/validate',
        method: 'post',
        data
    });
};
